declare global {
    interface String {
        isNullOrEmpty(): boolean;
    }
}

String.prototype.isNullOrEmpty = function (): boolean {
    return String(this) == undefined || String(this).length <= 0;
}


export { }; 